module.exports = __webpack_public_path__ + "img/avatar.a5e81f19.png";